export default __webpack_public_path__ + "static/media/Microsimulation methodology.bbf5234d.pdf";